import styled from 'styled-components';

export const Button = styled.button`
  color: ${(props) => props.color || props.theme.colors.textInverse};
  background: ${(props) => props.background || props.theme.colors.orange};
  width: ${(props) => props.width};
  height: ${(props) => props.height || '50px'};
  text-align: center;
  border-radius: ${(props) => props.theme.radii.lg};
  border: 1px solid;
  border-color: ${(props) => props.color || 'transparent'};
  font-weight: ${(props) => props.theme.fontWeights.bold};
  cursor: pointer;
  transition: opacity ${(props) => props.theme.transitions.base},
    background-color ${(props) => props.theme.transitions.base},
    color ${(props) => props.theme.transitions.base};
  ${(props) =>
    props.animate &&
    'animation-name: "pop"; animation-fill-mode: forwards; animation-duration: 0.5s'};

  :hover:not(:disabled) {
    ${(props) =>
      props.hover
        ? `background: ${props.color}; color: ${props.background};`
        : 'opacity: 0.85;'}
  }

  /* Foco e disabled nos tokens CCO — unifica com o resto do design.
     Defaults de cor/background ficam no tema: os callers passam cores
     explicitas e dependem deles. */
  :focus-visible {
    outline: 2px solid var(--cco-blue);
    outline-offset: 2px;
  }

  :disabled {
    cursor: not-allowed;
    background: var(--cco-soft-surface);
    color: var(--cco-ink-faint);
    border-color: var(--cco-line);
  }

  ${(props) => (props.maxWidth ? `max-width: ${props.maxWidth}` : '')}
`;
